export var notAvailable = function () { return ({
    code: 0,
    msg: 'JSBridge is not available'
}); };
export var notExist = function (apiName) { return ({
    code: 1,
    msg: "JSBridge: " + apiName + " not exist."
}); };
export var notSupported = function (apiName) { return ({
    code: 2,
    msg: "JSBridge: " + apiName + " not supported."
}); };
export var timeout = function (apiName) { return ({
    code: 3,
    msg: "JSBridge: " + apiName + " timeout."
}); };
